import React, { useCallback, useRef } from 'react';

export default function MobileBottomSheet({ isOpen, onClose, title, children, height = '60vh', noBackdrop = false }) {
  const sheetRef = useRef(null);
  const startY = useRef(0);
  const currentY = useRef(0);

  const handleTouchStart = useCallback((e) => {
    // Only track if touching the drag handle area (top 40px)
    const rect = sheetRef.current?.getBoundingClientRect();
    if (!rect) return;
    const touchY = e.touches[0].clientY;
    if (touchY - rect.top > 50) return; // Only drag from top area
    startY.current = touchY;
    currentY.current = touchY;
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!startY.current) return;
    currentY.current = e.touches[0].clientY;
    const delta = currentY.current - startY.current;
    if (delta > 0 && sheetRef.current) {
      sheetRef.current.style.transform = `translateY(${delta}px)`;
    }
  }, []);

  const handleTouchEnd = useCallback(() => {
    const delta = currentY.current - startY.current;
    if (sheetRef.current) {
      sheetRef.current.style.transform = '';
    }
    if (delta > 80) {
      onClose();
    }
    startY.current = 0;
    currentY.current = 0;
  }, [onClose]);

  return (
    <>
      {!noBackdrop && (
        <div
          className={`mobile-sheet-backdrop ${isOpen ? 'open' : ''}`}
          onClick={onClose}
        />
      )}
      <div
        ref={sheetRef}
        className={`mobile-bottom-sheet ${isOpen ? 'open' : ''}`}
        style={{ height, transform: isOpen ? undefined : 'translateY(100%)' }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="mobile-drag-handle" />
        {title && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '4px 16px 12px',
            borderBottom: '1px solid var(--selenny-border)',
            flexShrink: 0,
          }}>
            <span style={{ fontWeight: 600, fontSize: '15px' }}>{title}</span>
            <button
              onClick={onClose}
              style={{
                width: 32, height: 32, border: 'none', background: 'none',
                fontSize: '20px', cursor: 'pointer', color: 'var(--selenny-text)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                borderRadius: '8px',
              }}
            >
              ×
            </button>
          </div>
        )}
        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '12px 16px', WebkitOverflowScrolling: 'touch' }}>
          {children}
        </div>
      </div>
    </>
  );
}
